import CreateHocLazy from './create.hoc-lazy'

class DinoReduxBase {
  createHocLazy = CreateHocLazy
}

const DinoRedux = new DinoReduxBase()

export default DinoRedux
